module.exports = __webpack_public_path__ + "img/xid.fc74caad.svg";